import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface ActionsAreaProps {
  selectedCount: number
  children: ReactNode
}

const ActionsArea = ({ selectedCount, children }: ActionsAreaProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        padding: '12px 16px',
        backgroundColor: 'action.hover',
        borderRadius: 1,
        margin: '8px 0',
      }}
    >
      <Typography variant="body2" color="primary">
        {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
      </Typography>
      {children}
    </Box>
  )
}

export default ActionsArea
